import {Directive, HostListener, Input} from '@angular/core';
import {UHFInteractionService} from '../../api/services/uhf-interaction.service';
import {SiteURL} from '../../common/site.url.utils';

@Directive({
  selector: '[openAccountManagement]'
})
export class OpenAccountManagementDirective {
  @Input() siteURL: SiteURL;

  constructor(private uhfInteractionService: UHFInteractionService) {
    this.siteURL = SiteURL.ACCOUNT_MANAGEMENT
  }

  @HostListener('click', ['$event']) onClick($event: Event) {
    $event.preventDefault();
    this.uhfInteractionService.openAccountManagement(this.siteURL);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/open-account-management/open-account-management.directive.ts